import { render } from "./SocioNegocioList.vue?vue&type=template&id=1b3592af&scoped=true"
import script from "./SocioNegocioList.vue?vue&type=script&lang=js"
export * from "./SocioNegocioList.vue?vue&type=script&lang=js"

import "./SocioNegocioList.vue?vue&type=style&index=0&id=1b3592af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3592af"]])

export default __exports__